
import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { QueryStringService } from './query-string.service';
import { DOCUMENT } from '@angular/common';
import { IProgramDataService } from 'khegm-ui-components';

@Injectable({
  providedIn: 'root'
})
export class ProgramDataService implements IProgramDataService {
  constructor(private http: HttpClient, private qsp: QueryStringService, @Inject(DOCUMENT) private dom: Document) { }

  readonly siteName = 'Purdue Global'
  readonly externalInstitutionId = 'PGU';
  readonly programFinderExternalFeatureId = 'OD LP Program and Tuition Finder';
  readonly programEnabled = 'Yes';
  readonly hpFinderExternalFeatureId = 'Homepage Program Selector and Results';
  readonly apiBaseUrl = '/core/programs';

  getStartDate(siteName: string, externalInstitutionId: string) {
    return this.http.get(`${this.apiBaseUrl}/getstartandapplybydates?SiteName=${siteName}&ProgramEnabled=${this.programEnabled}&ExternalInstitutionId=${externalInstitutionId}`);
  }

  getStartDateById(siteName: string, programExternalId: any) {
    return this.http.get(`${this.apiBaseUrl}/getstartdatesbyid?ProgramExternalId=${programExternalId}&ProgramEnabled=${this.programEnabled}&SiteName=${siteName}`);
  }

  getProgramInfo(programExternalId: any) {
    const basePath = this.getAPIBasePath();
    return this.http.get(`${basePath}${this.apiBaseUrl}/getprograminfo?ExternalProgramId=${programExternalId}&ProgramEnabled=${this.programEnabled}&SiteName=${this.siteName}`);
  }

  getDegreeAndArea() {
    const basePath = this.getAPIBasePath();
    return this.http.get(`${basePath}${this.apiBaseUrl}/getdegreeandarea?SiteName=${this.siteName}&ProgramEnabled=${this.programEnabled}&ExternalInstitutionId=${this.externalInstitutionId}&ExternalFeatureId=${this.programFinderExternalFeatureId}`);
  }

  getAllProgramsAndOtherInfo() {
    const basePath = this.getAPIBasePath();
    return this.http.get(`${basePath}${this.apiBaseUrl}/getprogramsandotherinfo?ExternalInstitutionId=${this.externalInstitutionId}&ExternalFeatureId=${this.programFinderExternalFeatureId}&ProgramEnabled=${this.programEnabled}`);
  }

  /**
   * Returns the raw /getprograminfo response. Consumed by the library's
   * program finder component via the PROGRAM_DATA_SERVICE token.
   */
  getAllProgramInfo() {
    const basePath = this.getAPIBasePath();
    return this.http.get(`${basePath}${this.apiBaseUrl}/getprograminfo?SiteName=${this.siteName}&ExternalInstitutionId=${this.externalInstitutionId}&ExternalFeatureId=${this.programFinderExternalFeatureId}&ProgramEnabled=${this.programEnabled}`);
  }

  getHorizontalProgramInfo() {
    return this.http.get(`${this.apiBaseUrl}/getprograminfo?SiteName=${this.siteName}&ExternalInstitutionId=${this.externalInstitutionId}&ExternalFeatureId=${this.hpFinderExternalFeatureId}&ProgramEnabled=${this.programEnabled}`);
  }

  public getAPIBasePath(): string {
    const isGreenLive = this.qsp.getParameter('isGreenLive');
    const hostnameMapping = {
      'www-purdueglobal-dev.azurewebsites.net': 'https://www-dev-purdueglobal.mkt.kaplan.com',
      'www-purdueglobal-stage.azurewebsites.net': 'https://www-stage-purdueglobal.mkt.kaplan.com',
      'www-purdueglobal-release.azurewebsites.net': 'https://www-release-purdueglobal.mkt.kaplan.com',
      'www-purdueglobal.azurewebsites.net': isGreenLive ? 'https://www-green-live-purdueglobal.mkt.kaplan.com' : 'https://www.purdueglobal.edu',
    }
    return typeof window !== 'undefined' ? '' : hostnameMapping[this.dom.location.hostname] || '';
  }
  
}
